import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LockIcon, DownloadIcon, ShieldCheckIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  const [showFloating, setShowFloating] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowFloating(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <motion.section id="pricing-section" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="pb-24 md:pb-32" data-id="element-1">
        {/* Pricing Card */}
        <div className="bg-white border border-[#1B2A4A]/10 rounded-lg shadow-lg overflow-hidden" data-id="element-2">
          {/* Card Header */}
          <div className="bg-[#1B2A4A] px-6 py-4 text-center" data-id="element-3">
            <p className="text-white/80 text-sm font-sans uppercase tracking-widest" data-id="element-4">
              Limited Time Offer
            </p>
          </div>

          <div className="px-6 md:px-10 py-8 md:py-10" data-id="element-5">
            {/* Quick Value Summary */}
            <p className="text-center text-lg md:text-xl font-bold text-[#1B2A4A] mb-6" data-id="element-6">
              Everything you need to fix your Social Security check:
            </p>

            <div className="space-y-3 mb-8 max-w-md mx-auto" data-id="element-7">
              {['The "Un-Claim" Checklist & eligibility guide', "The Survivor Shield for your wife's benefit", 'Word-for-word SSA phone scripts', 'The Breakeven Calculator'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-8">
                  <CheckIcon className="w-5 h-5 text-[#D4652A] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-9" />
                  <span className="text-[#1B2A4A]/80 text-base" data-id="element-10">{item}</span>
                </div>)}
            </div>

            {/* Divider */}
            <div className="border-t border-[#1B2A4A]/10 my-8" data-id="element-11" />

            {/* Price Block */}
            <div className="text-center mb-8" data-id="element-12">
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-13">
                <span className="text-xl text-[#1B2A4A]/40 line-through font-sans" data-id="element-14">
                  $29.00
                </span>
                <span className="bg-[#D4652A] text-white text-xs font-bold px-2.5 py-1 rounded font-sans uppercase tracking-wide" data-id="element-15">
                  Save 78%
                </span>
              </div>
              <p className="text-[#1B2A4A] text-lg mb-1" data-id="element-16">Today only:</p>
              <p className="font-sans" data-id="element-17">
                <span className="text-5xl md:text-6xl font-bold text-[#D4652A]" data-id="element-18">
                  $6
                </span>
                <span className="text-3xl md:text-4xl font-bold text-[#D4652A]" data-id="element-19">
                  .36
                </span>
              </p>
              <p className="text-[#1B2A4A]/50 text-sm mt-2 font-sans" data-id="element-20">
                One-time payment — no subscriptions, no hidden fees
              </p>
            </div>

            {/* CTA Button */}
            <div className="text-center mb-6" data-id="element-21">
              <a href="https://www.betterbysteps.com/cart/44206228996189:1" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-2 px-8 md:px-10 py-5 text-lg md:text-xl font-bold text-white transition-all duration-200 bg-[#D4652A] rounded-lg shadow-[0_4px_14px_0_rgba(212,101,42,0.39)] hover:shadow-[0_6px_20px_rgba(212,101,42,0.5)] hover:scale-[1.02] hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4652A] font-sans w-full md:w-auto min-w-[320px] no-underline" data-id="element-22">
                RESET MY CLAIM NOW
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-23" />
              </a>
            </div>

            {/* Risk Reversal */}
            <p className="text-center text-sm text-[#1B2A4A]/60 italic mb-6" data-id="element-24">
              30-day money-back guarantee — if it doesn&apos;t help, you pay
              nothing.
            </p>

            {/* Trust Badges */}
            <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-xs text-[#1B2A4A]/50 font-sans border-t border-[#1B2A4A]/10 pt-6" data-id="element-25">
              <div className="flex items-center gap-1.5" data-id="element-26">
                <LockIcon className="w-3.5 h-3.5" data-id="element-27" />
                <span data-id="element-28">Secure 256-bit checkout</span>
              </div>
              <div className="hidden md:block w-1 h-1 bg-[#1B2A4A]/15 rounded-full" data-id="element-29" />
              <div className="flex items-center gap-1.5" data-id="element-30">
                <DownloadIcon className="w-3.5 h-3.5" data-id="element-31" />
                <span data-id="element-32">Instant PDF download</span>
              </div>
              <div className="hidden md:block w-1 h-1 bg-[#1B2A4A]/15 rounded-full" data-id="element-33" />
              <div className="flex items-center gap-1.5" data-id="element-34">
                <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-35" />
                <span data-id="element-36">30-day guarantee</span>
              </div>
            </div>
          </div>
        </div>

        {/* Closing line outside the card */}
        <p className="mt-8 text-lg text-[#1B2A4A] font-medium italic max-w-xl mx-auto text-center" data-id="element-37">
          &quot;Don&apos;t let a 5-minute decision at age 62 dictate your
          quality of life at age 80.&quot;
        </p>
      </motion.section>

      {/* Floating CTA — all screen sizes, appears on scroll */}
      <AnimatePresence data-id="element-38">
        {showFloating && <motion.div initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="fixed bottom-0 left-0 right-0 z-50" data-id="element-39">
            {/* Mobile: full-width orange bar */}
            <div className="md:hidden p-3 bg-[#D4652A] shadow-[0_-4px_20px_rgba(0,0,0,0.15)]" data-id="element-40">
              <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full py-3 px-4 bg-white text-[#D4652A] font-bold text-lg rounded shadow-sm font-sans active:scale-[0.98] transition-transform flex items-center justify-center gap-2" data-id="element-41">
                <span className="line-through text-[#D4652A]/50 text-sm" data-id="element-42">
                  $29
                </span>
                <span data-id="element-43">$6.36 — Reset My Claim Now</span>
              </button>
            </div>

            {/* Desktop: centered floating pill */}
            <div className="hidden md:flex justify-center pb-6" data-id="element-44">
              <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
            behavior: 'smooth'
          })} className="inline-flex items-center gap-3 px-8 py-3.5 bg-[#D4652A] text-white font-bold text-base rounded-full shadow-[0_4px_20px_rgba(212,101,42,0.4)] hover:shadow-[0_6px_28px_rgba(212,101,42,0.5)] hover:scale-[1.03] transition-all duration-200 font-sans" data-id="element-45">
                <span data-id="element-46">Reset My Claim Now</span>
                <span className="text-white/80" data-id="element-47">—</span>
                <span className="text-white/50 line-through text-sm" data-id="element-48">$29</span>
                <span className="text-white/90 font-normal" data-id="element-49">$6.36</span>
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}